export default __webpack_public_path__ + "01515ff56971594a429fd0f6fbef5e49.png";